import { PluginKey, type PluginsState } from '@databases/plugins';

import { createBaseModeConfig, type ModeConfig } from './default-mode-config';

const pluginsState: PluginsState = {
  [PluginKey.CELL_SELECTION]: () => true,
  [PluginKey.COMMENTS]: () => true,
  [PluginKey.CONTEXT_MENU]: () => true,
  [PluginKey.DATABASE_ACTIONS]: () => true,
  [PluginKey.EDIT_CONTENT]: () => true,
  [PluginKey.INLINE_DATABASE_NAME]: () => true,
  [PluginKey.QUICK_CALCULATIONS]: () => true,
  [PluginKey.VIEW_SETTINGS_ACTIONS]: () => true,
  [PluginKey.VIEW_SETTINGS_BUTTONS]: () => true,
};

export function createNativeEmbedModeConfig(): ModeConfig {
  /**
   * In native embed mode, this defaults to the LocalPanelManager
   * until swapped out once the initialization of the bridge is complete
   * where it then uses the NativeEmbedPanelManager.
   */
  return createBaseModeConfig({ plugins: pluginsState });
}
